import { useLocation } from 'react-router-dom';

import { checkIsYaotaiUser, useLoginInfo } from '@yaotai/common-utils';
import { NO_BANNER_ROUTE_PREFIX_LIST } from '../constants';

import { useUserInfo } from '.';

// 维护一些 center（活动中心）影响页面布局的变量
export function useCenterPageLayout() {
  const location = useLocation();
  const { isLogin } = useLoginInfo();
  const rbacUserInfo = useUserInfo();

  const isHidden = (list: string[]) => list.some(item => location.pathname.includes(item));

  const hasPCPhoneBindBanner =
    !isHidden(NO_BANNER_ROUTE_PREFIX_LIST) &&
    isLogin &&
    checkIsYaotaiUser(rbacUserInfo.login_type) &&
    !rbacUserInfo.phone;

  return {
    hasPCPhoneBindBanner,
  };
}
